import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=45a45095&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports